import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { HighlightPipe } from './pipes/highlight.pipe';
import { TypeaheadComponent } from './components/typeahead.component';


@NgModule({
    imports: [
        FormsModule,
        CommonModule,
    ],
    declarations: [
        HighlightPipe,
        TypeaheadComponent,
    ],
    exports: [
        TypeaheadComponent,
    ],
})

export class TypeaheadModule {}
